/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
// import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
// import MKInput from "components/MKInput";
// import MKButton from "components/MKButton";
// import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Image
// import bgImage from "assets/images/illustrations/illustration-reset.jpg";
// import Card from "assets/theme/components/card";
import ContactUsSection from "../AboutUs/sections/contactUs";
import Newsletter from "../AboutUs/sections/Newsletter";
import activeBg from "assets/images/contact_image.jpg";

function ContactUs() {
  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%" zIndex="1">
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/pages/landing-pages/contact-us",
            label: "contact us",
            color: "info",
          }}
        />
      </MKBox>
      <MKBox
        aria-hidden
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="53%"
        sx={({ functions: { linearGradient, rgba }, palette: { gradients } }) => ({
          backgroundImage: `${linearGradient(
            rgba(gradients.dark.main, 0.6),
            rgba(gradients.dark.state, 0.6)
          )}, url(${activeBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        })}
      />
      <MKBox pt={6} px={1} mt={15}>
        <ContactUsSection />
        <Newsletter />
      </MKBox>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ContactUs;
